import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export interface Participant {
  id: string;
  name: string;
}

interface ParticipantsProps {
  participants: Participant[];
  maxDisplay?: number;
}

export function Participants({ participants, maxDisplay = 2 }: ParticipantsProps) {
  const { t: tCommon } = useTranslation();
  const displayParticipants = participants.slice(0, maxDisplay);
  const remainingCount = participants.length - maxDisplay;
  const hasTooltip = remainingCount > 0;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={`flex items-center gap-2 px-2 bg-orange-50 border border-orange-200 rounded flex-wrap text-orange-700  ${hasTooltip ? 'cursor-help' : ''}`}
          data-testid="engagement-participants"
        >
          <Users className="w-3 h-3 text-orange-600 shrink-0" />
          {(displayParticipants || [])
            .map(participant => participant.name)
            .join(tCommon('format.listSeparator'))}
          {remainingCount > 0 && ` +${remainingCount}`}
        </div>
      </TooltipTrigger>
      {hasTooltip && (
        <TooltipContent side="top" className="max-w-xs">
          <div className="text-xs space-y-1">
            {participants.map(participant => (
              <div key={participant.id} className="text-left">
                {participant.name}
              </div>
            ))}
          </div>
        </TooltipContent>
      )}
    </Tooltip>
  );
}
